export default "__VITE_ASSET__881a3b2c__"